import type { FilterDropdownOption } from '@/shared/ui/FilterDropdown';

import type {
  DagFavoriteFilterValue,
  DagMaturityFilterValue,
  DagRunStatusFilterValue,
} from '@/features/dag-list/model/types';

export const DAG_RUN_STATUS_FILTER_OPTIONS: FilterDropdownOption<DagRunStatusFilterValue>[] = [
  {
    key: 'all',
    label: 'All',
    value: 'all',
  },
  {
    key: 'draft',
    label: 'Draft',
    value: 'draft',
  },
  {
    key: 'failure',
    label: 'Failure',
    value: 'failure',
  },
  {
    key: 'pending',
    label: 'Pending',
    value: 'pending',
  },
  {
    key: 'running',
    label: 'Running',
    value: 'running',
  },
  {
    key: 'success',
    label: 'Success',
    value: 'success',
  },
];

export const DAG_FAVORITE_FILTER_OPTIONS: FilterDropdownOption<DagFavoriteFilterValue>[] = [
  {
    key: 'all',
    label: 'All',
    value: 'all',
  },
  {
    key: 'favorites',
    label: 'Favorites',
    value: 'favorites',
  },
  {
    key: 'non-favorites',
    label: 'Non Favorites',
    value: 'non-favorites',
  },
];

export const DAG_MATURITY_FILTER_OPTIONS: FilterDropdownOption<DagMaturityFilterValue>[] = [
  {
    key: 'all',
    label: 'All',
    value: 'all',
  },
  {
    key: 'bronze',
    label: 'Bronze',
    value: 'bronze',
  },
  {
    key: 'silver',
    label: 'Silver',
    value: 'silver',
  },
  {
    key: 'gold',
    label: 'Gold',
    value: 'gold',
  },
];
